export default __webpack_public_path__ + "static/media/golang.73c6dbd9.svg";